import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CheckboxWithLabel from '../CheckboxWithLabel'
import FormControlsGroup from '../FormControlsGroup'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import SortSelecter from '../SortSelecter'
import Switch from '@mui/material/Switch'
import NumericTextboxWithLabel from '../NumericTextboxWithLabel'
import TraitLevelFilter from '../TraitLevelFilter'
import './SortFilter.css'

const SortFilter = ({ filters, isWallet, onFilterChange, onSortByChange, onViewToggled }) => {
    const [sortBy, setSort] = useState('probability')
    // const [filtersVisible, setFiltersVisible] = useState(false)

    const handleFilterChange = ({ target }) => {
        switch (target.name) {
            // Numbers
            case 'minProbability':
            case 'maxTotalCost':
            case 'summonsRemaining':
            case 'maxSummons':
            case 'minGen':
            case 'maxGen':
                onFilterChange({ key: target.name, value: Number(target.value) })
                break

            // Text
            case 'traitFocus':
                onFilterChange({ key: target.name, value: target.value })
                break

            // Checkboxes
            case 'classMatch':
            case 'subclassMatch':
            case 'professionMatch':
            case 'includeSummonClass':
            case 'includeAllHeroes':
                onFilterChange({ key: target.name, value: target.checked })
                break

            default:
                console.log('unknown search filter selected')
        }
    }

    // const handleFiltersToggled = (event) => {
    //     setFiltersVisible(event.target.checked)
    // }

    const handleViewToggled = event => {
        onViewToggled(event.target.checked)
    }

    const handleSortByChange = ({ target }) => {
        setSort(target.value)
        onSortByChange(target.value)
    }

    const visibleClass = '' //filtersVisible ? '' : 'hidden'

    return (
        <Grid container className="sort-filter">
            <Grid item className="section">
                <Switch defaultChecked={false} onChange={handleViewToggled} />
                Flip Cards
                {/* <Switch checked={filtersVisible} onChange={handleFiltersToggled} />
                Toggle Filters */}
            </Grid>
            <Grid item className={`section ${visibleClass}`}>
                <SortSelecter name="sort-by" value={sortBy} onChange={handleSortByChange}>
                    <MenuItem key="probability" value="probability">
                        Probability
                    </MenuItem>
                    <MenuItem key="price" value="price">
                        Price
                    </MenuItem>
                </SortSelecter>
            </Grid>
            <Grid item className={`section ${visibleClass}`}>
                <div className="filter-label">Filters:</div>
                <FormControlsGroup title="Probability">
                    <NumericTextboxWithLabel
                        label="Min"
                        maxValue={100}
                        name="minProbability"
                        value={filters.minProbability}
                        onChange={handleFilterChange}
                    />
                </FormControlsGroup>
                <FormControlsGroup title="Total Cost">
                    <NumericTextboxWithLabel
                        label="Max"
                        name="maxTotalCost"
                        value={filters.maxTotalCost}
                        onChange={handleFilterChange}
                    />
                </FormControlsGroup>
                <FormControlsGroup title="Summons">
                    <NumericTextboxWithLabel
                        label="Remaining"
                        maxValue={10}
                        name="summonsRemaining"
                        value={filters.summonsRemaining}
                        onChange={handleFilterChange}
                    />
                    <NumericTextboxWithLabel
                        label="Max"
                        maxValue={10}
                        name="maxSummons"
                        value={filters.maxSummons}
                        onChange={handleFilterChange}
                    />
                </FormControlsGroup>
                <FormControlsGroup title="Generation">
                    <NumericTextboxWithLabel
                        label="Min"
                        maxValue={14}
                        name="minGen"
                        value={filters.minGen}
                        onChange={handleFilterChange}
                    />
                    <NumericTextboxWithLabel
                        label="Max"
                        hideZero={false}
                        maxValue={14}
                        name="maxGen"
                        value={filters.maxGen}
                        onChange={handleFilterChange}
                    />
                </FormControlsGroup>
                <FormControlsGroup title="D/R1 Gene Match" className="extra-margin">
                    <CheckboxWithLabel
                        label="Class"
                        name="classMatch"
                        value={filters.classMatch}
                        onChange={handleFilterChange}
                    />
                    <CheckboxWithLabel
                        label="Subclass"
                        name="subclassMatch"
                        value={filters.subclassMatch}
                        onChange={handleFilterChange}
                    />
                    <CheckboxWithLabel
                        label="Profession"
                        name="professionMatch"
                        value={filters.professionMatch}
                        onChange={handleFilterChange}
                    />
                </FormControlsGroup>
                <FormControlsGroup title="Include" className="extra-margin">
                    <CheckboxWithLabel
                        label="Summon Class"
                        name="includeSummonClass"
                        tooltip="Also show matches whose main class is the desired summmoned class"
                        value={filters.includeSummonClass}
                        onChange={handleFilterChange}
                    />
                    {isWallet && (
                        <CheckboxWithLabel
                            label="All Heroes"
                            name="includeAllHeroes"
                            tooltip="Include all heroes in wallet even those who are not a match."
                            value={filters.includeAllHeroes}
                            onChange={handleFilterChange}
                        />
                    )}
                </FormControlsGroup>
                <FormControlsGroup title="Trait Focus" className="extra-margin">
                    <TraitLevelFilter
                        label="Basic"
                        name="traitFocus"
                        value={filters.traitFocus}
                        onChange={handleFilterChange}
                    />
                </FormControlsGroup>
            </Grid>
        </Grid>
    )
}

SortFilter.propTypes = {
    filters: PropTypes.object,
    isWallet: PropTypes.bool.isRequired,
    onFilterChange: PropTypes.func,
    onSortByChange: PropTypes.func,
    onViewToggled: PropTypes.func,
}

SortFilter.defaultProps = {
    filters: {},
    onFilterChange: () => {},
    onSortByChange: () => {},
    onViewToggled: () => {},
}

export default SortFilter
